import React from "react";
import { useTranslation } from "react-i18next";

type Props = {
    estimated: boolean;
};

export const GradeBarChartKey = (props: Props) => {
    const { estimated } = props;
    const { t } = useTranslation("common");

    return (
        <div className="col-12 lg:col-4">
            <div className="grade-key-container">
                <small className="grade-key-header">
                    {`${t("inspectionReport.gradeComparison.key")}`}
                </small>
                <div className="flex justify-content-between">
                    <div>
                        <small className="grade-key-info">
                            {`${t(
                                estimated
                                    ? "inspectionReport.gradeComparison.estimatedIdwalGrade"
                                    : "inspectionReport.gradeComparison.yourIdwalGrade"
                            )}`}
                        </small>
                        <div className="grade-key-line" />
                    </div>
                    <div>
                        <small className="grade-key-info">
                            {`${t(
                                "inspectionReport.gradeComparison.averageIdwalGrade"
                            )}`}
                        </small>
                        <div>
                            <svg
                                className="grade-key-dash"
                                width="50"
                                height="21"
                                viewBox="0 0 50 21"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M10 12.0176L1.74846e-07 12.0176L0 10.0176L10 10.0176L10 12.0176Z"
                                    fill="#28235B"
                                />
                                <path
                                    d="M30 12.0176L20 12.0176L20 10.0176L30 10.0176L30 12.0176Z"
                                    fill="#28235B"
                                />
                                <path
                                    d="M50 12.0176L40 12.0176L40 10.0176L50 10.0176L50 12.0176Z"
                                    fill="#28235B"
                                />
                            </svg>
                        </div>
                    </div>
                </div>
                <div className="flex flex-column">
                    <small className="grade-key-info">
                        {`${t("inspectionReport.gradeComparison.gradeRange")}`}
                    </small>
                    <div className="flex justify-content-between mt-3">
                        <div className="flex align-items-center">
                            <div className="grade-key-range grade-key-90" />
                            <small className="grade-key-info">≥ 90</small>
                        </div>
                        <div className="flex align-items-center">
                            <div className="grade-key-range grade-key-70" />
                            <small className="grade-key-info">70 - 89</small>
                        </div>
                        <div className="flex align-items-center">
                            <div className="grade-key-range grade-key-50" />
                            <small className="grade-key-info">50 - 69</small>
                        </div>
                        <div className="flex align-items-center">
                            <div className="grade-key-range grade-key-30" />
                            <small className="grade-key-info">30 - 49</small>
                        </div>
                    </div>
                </div>
            </div>
            <p className="grade-info">
                {`${t("inspectionReport.gradeComparison.barChartKey")}`}
            </p>
        </div>
    );
};
